// @core/api/endpoints/workflow/set_breakpoint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DebugSessionResponse,
  SetBreakpointRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Set breakpoint
 * Adds a breakpoint at a specific node. Optionally set a CEL condition.
 */
export async function SetBreakpoint(
  session_id: string,
  data: SetBreakpointRequest,
  options?: RequestOptions
): Promise<DebugSessionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/debug/:session_id/breakpoints`;
  requestPath = requestPath.replace(':session_id', encodeURIComponent(session_id));
  const requestOptions = options;
  return client.post<DebugSessionResponse>(requestPath, data, requestOptions);
}
